/*
  Alpha Zen redesign: rotating announcement bar and the email-gated
  "Get my code" modal, per design/build-the-reviewed-alpha-zen-site-mockup/home.html.

  The bar cross-fades between its messages. The gate opens from the "Get my code"
  button in the bar, closes on the X, on Escape, and on a click outside the box.
  The form itself is handled by az-email-capture.js.
*/
(function () {
  function initBar(bar) {
    const messages = Array.from(bar.querySelectorAll('.msg'));
    if (messages.length < 2) return;

    const speed = (parseInt(bar.dataset.azSpeed, 10) || 5) * 1000;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches) return;

    let index = 0;
    setInterval(function () {
      messages[index].classList.remove('on');
      index = (index + 1) % messages.length;
      messages[index].classList.add('on');
    }, speed);
  }

  function initGate(gate) {
    const box = gate.querySelector('.gatebox');
    const opener = document.querySelector('[data-az-gate-open]');
    const closer = gate.querySelector('[data-az-gate-close]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      gate.hidden = false;
      const field = gate.querySelector('input[type="email"]');
      if (field) field.focus();
    }

    function close() {
      gate.hidden = true;
      if (lastFocused) lastFocused.focus();
    }

    if (opener) opener.addEventListener('click', open);
    if (closer) closer.addEventListener('click', close);

    gate.addEventListener('click', function (event) {
      if (box && !box.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !gate.hidden) close();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-az-bar]').forEach(initBar);
    (root || document).querySelectorAll('[data-az-gate]').forEach(initGate);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
